import {
  Box,
  Button,
  Grid,
  Link,
  SpaceBetween,
  FormField,
  Input,
  StatusIndicator,
  Checkbox,
  Form,
  Popover,
  Autosuggest,
  Alert,
  RadioGroup,
  ContentLayout,
  Container,
} from "@cloudscape-design/components";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { withAuthenticator, Authenticator } from '@aws-amplify/ui-react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { navigateFn } from "../../../routingHelper";
import useAxios, {
  configure,
  loadCache,
  serializeCache,
  makeUseAxios,
} from 'axios-hooks'
import { leagueId, apiKey, baseUrl } from '../../../leagueId';
import { RotatingLines, ThreeDots, BallTriangle } from  'react-loader-spinner'
import * as awsui from "@cloudscape-design/design-tokens";
import usePlacesService from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import DatePicker from '../../../components/date-picker/DatePicker';
import { useLocalStorage } from 'usehooks-ts';
import { CustomButton } from "../../../components/buttons";


function MotorsportAdmin() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const { 
    userAttributes, setUserAttributes,
  } = useContext(GlobalContext);
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const { route } = useAuthenticator(context => [context.route]); 
  const { authStatus } = useAuthenticator(context => [context.authStatus]); 


  return (
    <>   
      <center>
        <ContentLayout
          header={
            <div 
              className="account-header-container" 
              style={{ 
                height: "100px",
                maxHeight: "100px",
                width: "100%",
                zIndex: "3",
              }} 
            />
          }
        >
          <div className="body-content">
            <Container>
              <center>Motorsport Admin Navigation</center>
            </Container>
          </div>
        </ContentLayout>
      </center>
      <center>
        <div style={{width: "100%", paddingTop: "50px", paddingBottom: "50px"}}>
          <div className="body-content">   
            Motorsport Admin Page
          </div>
        </div>
      </center>
    </>
  );
}


export default withAuthenticator(MotorsportAdmin);